import {Injectable} from '@angular/core';
import {HhsgSharedUserProfile} from '../models/user-profile.model';
import {firstValueFrom, Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {HhsgSharedUserService} from './user.service';
import {HhsgSharedConfigService} from "./config.service";
import {HhsgSharedHttpService} from "./http.service";
import {map} from "rxjs/operators";
import {UserDataResult} from "angular-auth-oidc-client";

@Injectable({
  providedIn: 'root'
})
export class HhsgSharedUserProfileService {

  private readonly _apiServer: string;
  private readonly _hapProfileControllerName = 'Profile';
    constructor(private _http: HttpClient,
        private _httpService: HhsgSharedHttpService,
        private _userService: HhsgSharedUserService,
        private _configService: HhsgSharedConfigService,) {
      this._apiServer = _configService.appSettings.stsServer;
    }


  public getSessionUserProfile(): Observable<HhsgSharedUserProfile>{
    return this._userService.getUserProfile();
  }

  public setSessionUserProfile(profile: HhsgSharedUserProfile) {
    this._userService.setUserProfile(profile);
  }

  /**
   * @deprecated This method is deprecated.
   * Use populateUserProfileFromHap that returns an observable instead.
   */
  public async populateUserProfile(userDataResult: any, controllerUrl: string) : Promise<HhsgSharedUserProfile> {
    if (!userDataResult || !userDataResult.userData) {
      return;
    }

    var userProfile = await this.createUserProfiles(userDataResult.userData, controllerUrl);
    return userProfile;
  }

  public async getUserProfileData(controllerUrl: string) : Promise<HhsgSharedUserProfile> {
    if (controllerUrl) {
      return firstValueFrom(this._http.get<HhsgSharedUserProfile>(`${controllerUrl}GetUserProfileData`));
    } else {
      return new HhsgSharedUserProfile();
    }
  }

  public populateUserProfileFromHap(userDataResult: UserDataResult): Observable<HhsgSharedUserProfile> {
    if (!userDataResult || !userDataResult?.userData ) {
      return;
    }

    let params = new HttpParams()
      .append("includeSourceApplication", "true")
      .append("includeUserApplicationWithNobackdoorlogin", "false");
    return this._httpService.doGetRequestWithParams<HhsgSharedUserProfile>(this._apiServer, this. _hapProfileControllerName, `GetUserProfileData`, params)
      .pipe(map(hapProfileData=> {
          let mergedProfile = this.mergeTokenAndHapDbProfiles(userDataResult, hapProfileData);
          this.setSessionUserProfile(mergedProfile);

          return mergedProfile;
        })
      );
  }

  private mergeTokenAndHapDbProfiles(userDataResult: UserDataResult, hapProfileData: HhsgSharedUserProfile) : HhsgSharedUserProfile {
    let userProfile = this.mapUserProfileFromToken(userDataResult?.userData);
    let mergedUserProfile = { ...userProfile, ...hapProfileData } as HhsgSharedUserProfile;
    mergedUserProfile.roles = userProfile.roles.concat(hapProfileData.roles);

    return mergedUserProfile;
  }

  /**
   * @deprecated This method is deprecated.
   * Use populateUserProfileFromHap that returns an observable instead.
   */
  protected async createUserProfiles(userData: any, controllerUrl: string) : Promise<HhsgSharedUserProfile> {
      let userProfile = this.mapUserProfileFromToken(userData);
      let hapProfileData = await this.getUserProfileData(controllerUrl);

      let updatedUserProfile = { ...userProfile, ...hapProfileData } as HhsgSharedUserProfile;
      let allUserRoles = userProfile.roles.concat(hapProfileData.roles);
      updatedUserProfile.roles = allUserRoles;
      this._userService.setUserProfile(updatedUserProfile);
      return updatedUserProfile;
  }

  protected mapUserProfileFromToken(userData: any) : HhsgSharedUserProfile {
      let hapRoles = userData?.role instanceof Array ? userData?.role : [ userData?.role ];
      let applicationRoles = this.getRolesFromCustomClaims(userData);
      let allRoles = applicationRoles?.concat(hapRoles);

      return <HhsgSharedUserProfile> {
          brandingName: userData?.brandingName,
          userId: userData?.sub,
          firstName: userData?.given_name,
          lastName: userData?.family_name,
          email: userData?.email,
          corporationId: userData?.corporationId,
          roles: allRoles ?? []
      };
  }

  protected getRolesFromCustomClaims(token: any) : string[] {
    let applicationRoles = token?.customUserApplicationClaim?.split(",");
    return applicationRoles;
  }
}
